import { render, staticRenderFns } from "./LaundrySpAssignment.vue?vue&type=template&id=e2ef7434"
import script from "./LaundrySpAssignment.vue?vue&type=script&lang=js"
export * from "./LaundrySpAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports